<div class="h-100">
    <router-outlet></router-outlet>
    <footer class="footer mt-3">
        <!-- <span class="copyright">&#169; Copyright 2022 Upjao Agrotech Private Limited Version: {{version}}</span> -->
    </footer>
</div>